import location from './location';
import params from './params';

export function twitterShare(text, link) {
    link = (link && typeof link == "string")?link:location();
    if(text && typeof text != "object"){
        text = encodeURIComponent(text);
    }
    else{
        text = "";
    }
    window.open('https://twitter.com/share?url=' + link +'&text='+text, 'twitterwindow', params);
};